export default "__VITE_ASSET__dc8f2044__"